import { gql } from '../../../apollo/__generated__';

export const TINDER_SUPER_LIKED_USERS = gql(`
  query TinderSuperLikedUsers($eventId: ID!) {
    tinderSuperLikedUsers(eventId: $eventId) {
      id
      firstname
      lastname
      nickname
      studies
      studyTown
      folklore
      tinderSuperLikeCount(eventId: $eventId)
    }
  }
`);
